import React from 'react';
import './styles.scss';

const ErrorPage: React.FC = () => {
    return (
        <React.Fragment>
            <div className="error-page">
                <p className="error-page-block">
                    <span className="error-page-block__sign">:(</span>
                    <br/>
                    <span>Что-то пошло не так...</span>
                </p>
            </div>
        </React.Fragment>
    );
};

export default ErrorPage;
